import CustomDatatableWithSearch from 'libs/datatables/custom_datatable_with_search'

export default function initShowTag() {
  const { $ } = window

  $(document).on('ready', () => {
    const $commonElements = $('#common_elements')
    if ($commonElements.length === 0) return

    const selector = 'table.custom-datatable tbody td:not(.actions):not(.element-table-photos):not(.gallery)'
    $commonElements.on('click', selector, (e) => {
      window.location.href = $(e.currentTarget).parent('tr').data('url')
    })

    $commonElements.find('.element-group').each(function () {
      const table = $(this).find('table')
      const search = $(this).find('input.search')
      let sortColumn = $(table).data('sortColumn')
      if (sortColumn === undefined) {
        sortColumn = 1
      }
      const order = [[sortColumn, 'asc']]
      new CustomDatatableWithSearch(table, search, { order, disableCompactMode: true })
    })
  })
}
